export enum OnboardingContractActionType {
  GET_ALL_ONBOARDING_CONTRACTS_FAILURE = '@@onboarding-contract/GET_ALL_ONBOARDING_CONTRACTS_FAILURE',
  GET_ALL_ONBOARDING_CONTRACTS_REQUEST = '@@onboarding-contract/GET_ALL_ONBOARDING_CONTRACTS_REQUEST',
  GET_ALL_ONBOARDING_CONTRACTS_SUCCESS = '@@onboarding-contract/GET_ALL_ONBOARDING_CONTRACTS_SUCCESS',

  GET_SIGNED_ONBOARDING_CONTRACTS_FAILURE = '@@onboarding-contract/GET_SIGNED_ONBOARDING_CONTRACTS_FAILURE',
  GET_SIGNED_ONBOARDING_CONTRACTS_REQUEST = '@@onboarding-contract/GET_SIGNED_ONBOARDING_CONTRACTS_REQUEST',
  GET_SIGNED_ONBOARDING_CONTRACTS_SUCCESS = '@@onboarding-contract/GET_SIGNED_ONBOARDING_CONTRACTS_SUCCESS',

  SIGN_ONBOARDING_CONTRACT_FAILURE_CLIENT = '@@onboarding-contract/SIGN_ONBOARDING_CONTRACT_FAILURE_CLIENT',
  SIGN_ONBOARDING_CONTRACT_REQUEST_CLIENT = '@@onboarding-contract/SIGN_ONBOARDING_CONTRACT_REQUEST_CLIENT',
  SIGN_ONBOARDING_CONTRACT_SUCCESS_CLIENT = '@@onboarding-contract/SIGN_ONBOARDING_CONTRACT_SUCCESS_CLIENT',
}
